import {adminServerInstance} from '../axios/instances';
import { CREATE_SECOND_DELIVERY_BATCH, 
    CREATE_SECOND_DELIVERY_BATCH_FAIL, 
    CREATE_SECOND_DELIVERY_BATCH_SUCCESS, 
    GET_SECOND_DELIVERY_ORDERS, 
    GET_SECOND_DELIVERY_ORDERS_FAIL, 
    GET_SECOND_DELIVERY_ORDERS_SUCCESS} from './types';

export const fetchSecondDeliveryOrders = (branchId, dateFrom, dateTo) => (dispatch) => {
    dispatch({type: GET_SECOND_DELIVERY_ORDERS})
    return adminServerInstance.get('/map/getseconddeliveryorders', {
        params: {
            branch: branchId,
            start: dateFrom.unix(),
            end: dateTo.unix()
        }
    }).then(({data}) => {
        dispatch({
            type: GET_SECOND_DELIVERY_ORDERS_SUCCESS,
            payload: data.data
        })
        return Promise.resolve(data.data);
    }).catch(error => {
        dispatch({
            type: GET_SECOND_DELIVERY_ORDERS_FAIL,
            payload: error
        })
        return Promise.reject(error);
    })
};

export const batchUpdateSecondDeliveryOrders = () => (dispatch) => {
    return adminServerInstance
        .post(`/driver/batchcompleteseconddelivery?version=1.0`)
        .then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error); 
        })
};

export const createSecondDeliveryBatch = (branchId, orderIds) => (dispatch) => {
    dispatch({type: CREATE_SECOND_DELIVERY_BATCH})
    return adminServerInstance.post('cargo/createsecondeliverybatch', {
        branch: branchId,
        order_ids: orderIds.toString()
    }).then(({data}) => {
        dispatch({
            type: CREATE_SECOND_DELIVERY_BATCH_SUCCESS,
            payload: data.data
        })
        return Promise.resolve(data.data);
    }).catch(error => {
        dispatch({
            type: CREATE_SECOND_DELIVERY_BATCH_FAIL,
            payload: error
        })
        return Promise.reject(error);
    })
}